module.exports = "/_next/static/images/percentagealt-d5f743db89b8823b59d84fc9f5598332.svg";